export default {"src":"/_next/static/media/fixedPrice.54e4605f.svg","height":100,"width":101};